import { createSlice } from "@reduxjs/toolkit";
import { readAsyncStorageValues } from "./actions";

const initialState = {
  loading: false,
  asyncStorageValues: {},
  indianStateDropdownOptions: [],
  indianStateDropdownOptionsCodeOnly: [],
  machineModels: [],
  error: null,
  success: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: {
    [readAsyncStorageValues.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [readAsyncStorageValues.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.asyncStorageValues = payload.asyncStorageValues;
      state.indianStateDropdownOptions = payload.indianStateDropdownOptions;
      state.indianStateDropdownOptionsCodeOnly = payload.indianStateDropdownOptionsCodeOnly;
      state.machineModels = payload.machineModels;
    },
    [readAsyncStorageValues.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default commonSlice.reducer;
